import { render, staticRenderFns } from "./BasicChatElement.vue?vue&type=template&id=b59ddf32&"
import script from "./BasicChatElement.vue?vue&type=script&lang=js&"
export * from "./BasicChatElement.vue?vue&type=script&lang=js&"
import style0 from "./BasicChatElement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports